import {GENERAL_TYPES} from '../constants/general.types'
import {GeneralAction, GeneralState} from '../interfaces/general.interface'

const initialState: GeneralState = {
  modalEdit: {
    open: false,
    title: '',
    message: '',
    onConfirmEdit: null
  },
  modalError: {
    open: false,
    message: '',
    tipo: 500,
  },
  modalInfo: {
    open: false,
    message: '',
  },
  modalSuscripcion: {
    open: false,
  },
  modalMessage: {
    open: false,
    title: '',
    message: '',
  },
  toast: {
    open: false,
    title: '',
    message: '',
    tipo: 1 /* 0 = error, 1 = success, 2 = info */,
  },
  modalLimite: {
    open: false,
    title: "",
    message: "",
    color: "black",
    limite: 0
  },
  loader: false,
  fecha_actual: null,
  validReturnHome: "",
}

const generalReducer = (
  state: GeneralState = initialState,
  action: GeneralAction
): GeneralState => {
  switch (action.type) {
    case GENERAL_TYPES.OPEN_MODAL_ERROR:
      return {...state, modalError: {...action.payload}}
    case GENERAL_TYPES.CLOSE_MODAL_ERROR:
      return {...state, modalError: initialState.modalError}
    case GENERAL_TYPES.SHOW_LOADER:
      return {...state, loader: action.payload}
    case GENERAL_TYPES.OPEN_MODAL_INFO:
      return {...state, modalInfo: {...action.payload}}
    case GENERAL_TYPES.CLOSE_MODAL_INFO:
      return {...state, modalInfo: initialState.modalInfo}
    case GENERAL_TYPES.OPEN_MODAL_MESSAGE:
      return {...state, modalMessage: {...action.payload}}
    case GENERAL_TYPES.CLOSE_MODAL_MESSAGE:
      return {...state, modalMessage: initialState.modalMessage}
    case GENERAL_TYPES.OPEN_MODAL_SUSCRIPCION:
      return {...state, modalSuscripcion: {open: true}}
    case GENERAL_TYPES.CLOSE_MODAL_SUSCRIPCION:
      return {...state, modalSuscripcion: initialState.modalSuscripcion}
    case GENERAL_TYPES.OPEN_TOAST:
      return {...state, toast: action.payload}
    case GENERAL_TYPES.CLOSE_TOAST:
      return {...state, toast: initialState.toast}
    case GENERAL_TYPES.OPEN_MODAL_LIMITE:
      return {...state, modalLimite: action.payload}
    case GENERAL_TYPES.CLOSE_MODAL_LIMITE:
      return {...state, modalLimite: initialState.modalLimite}
    case GENERAL_TYPES.GENERAL_ACTIVE_MODA_EDIT:
      return {...state, modalEdit: action.payload}
    case GENERAL_TYPES.GENERAL_SET_HORA:
      return {...state, fecha_actual: action.payload}
    case GENERAL_TYPES.GENERAL_SET_RETURN_VALID:
      return {...state, validReturnHome: action.payload}
    default:
      return state
  }
}

export default generalReducer
